<script lang="ts">
  import { defineComponent } from 'vue';
  import { getMobileInsetsData } from '@/helpers/utils';
  import { InsetDirection } from '@/helpers/enums';
  import { MobileInsetsData } from '@/providers/laundryheap/interfaces/general';

  export default defineComponent({
    props: {
      disableInsets: {
        type: Array as () => InsetDirection[],
        default: () => [] as InsetDirection[],
      },
      dark: { type: Boolean, default: false },
    },
    data() {
      return {
        insets: getMobileInsetsData(),
      };
    },
    computed: {
      keyboardShown(): boolean {
        return this.$store.state.keyboardOpen;
      },
      filteredInsets(): MobileInsetsData {
        return {
          top: this.isInsetDisabled(InsetDirection.top)
            ? 0
            : this.insets?.top || 0,
          bottom:
            this.isInsetDisabled(InsetDirection.bottom) || this.keyboardShown
              ? 0
              : this.insets?.bottom || 0,
          left: this.isInsetDisabled(InsetDirection.left)
            ? 0
            : this.insets?.left || 0,
          right: this.isInsetDisabled(InsetDirection.right)
            ? 0
            : this.insets?.right || 0,
        };
      },
      containerStyle(): object {
        return {
          paddingTop: `${this.filteredInsets.top}px`,
          paddingBottom: `${this.filteredInsets.bottom}px`,
          paddingLeft: `${this.filteredInsets.left}px`,
          paddingRight: `${this.filteredInsets.right}px`,
        };
      },
    },
    methods: {
      isInsetDisabled(direction: InsetDirection): boolean {
        return this.disableInsets?.includes(direction);
      },
    },
  });
</script>

<template>
  <div
    class="flex-container"
    :class="{ 'flex-container--dark': dark }"
    :style="containerStyle"
  >
    <slot></slot>
  </div>
</template>
